export default __webpack_public_path__ + "static/media/my-photo.a64beb03.jpg";